module.exports = __webpack_public_path__ + "static/media/6.10b3b533.png";